import Swiper from 'swiper/bundle';

const isMobile = () => {
  return window.innerWidth < 768;
}

const dataMobileLabel = document.querySelector('[data-mobile-label]')

const replaceLinks = (value) => {
  document.querySelectorAll('[data-link]').forEach(link => link.href = value)
}

const replaceLabels = (value) => {
  document.querySelectorAll('[data-cta]').forEach(link => link.innerText = value)
}

const pauseVideos = () => {
  document.querySelectorAll("[data-swiper-video] video").forEach(v => v.pause())
}

const initLinks = () => {
  document.querySelectorAll("[data-frame-link]")
    .forEach(v => {
      v.addEventListener('click',(event) => {

        const index = event.target.getAttribute("data-frame-link")

        window.customswiper.slideTo(index)
      })
    })
}

const initVideos = () => {
  const total = document.querySelectorAll("[data-swiper-video] video").length
  document.querySelectorAll("[data-swiper-video] video").forEach(v => {
    v.addEventListener("ended",() => {
      const index = v.getAttribute("data-index")
      if (index == total - 1) {
        window.customswiper.slideTo(0,10)
      } else {
        window.customswiper.slideNext()
      }
    })
  })
}

const resetLinks = () => {
  document.querySelectorAll("[data-frame-link]")
    .forEach(v => v.classList.remove('underline'))
}

const setCurrentVideo = () => {
  const activeVideo = document.querySelector(".swiper-slide-active")
  const videoIndex = activeVideo.getAttribute("data-swiper-video")

  const selector = `video${isMobile() ? '.is-mobile' : '.is-desktop'}`

  activeVideo.querySelector(selector).play()
  document.querySelector('[data-frame-link="'+videoIndex+'"]').classList.add('underline')

  replaceLinks(activeVideo.getAttribute("data-video-url"))

  replaceLabels(isMobile() ? activeVideo.getAttribute("data-video-cta-mobile") : activeVideo.getAttribute("data-video-cta-desktop"))
  dataMobileLabel.innerText = isMobile() ? activeVideo.getAttribute("data-video-title-mobile") : activeVideo.getAttribute("data-video-title-desktop")
}

window.customswiper = new Swiper(".mySwiper", {
  direction: "vertical",
  slidesPerView: 1,
  loop: false,
  speed: 1000,
  mousewheel: {
    releaseOnEdges: true,
  },
});

window.customswiper.on("slideChangeTransitionEnd", () => {
  setCurrentVideo()
})

window.customswiper.on("slideChangeTransitionStart", (e) => {
  pauseVideos()
  resetLinks()
})

setCurrentVideo()
initLinks()
initVideos()


